module.exports = __webpack_public_path__ + "static/media/COTTON_1x.0766f258.png";